import { Type as IconType } from '@ui/components/Icon/Icon.interfaces';

export enum TripWidgetStatusType {
    Initial,
    Loading,
    Success,
    Error,
}
export interface Trip {
    type: TripType;
    code: string;
    image: string | null;
    labelKey: string | null;
    stops: TripStop[];
    rows: TripRow[];
}

export enum TripType {
    Country = 'Country',
    City = 'City',
}

interface TripRow {
    icon: IconType;
    labelKey: string;
}

export interface TripDestination {
    label: string;
    country: string | null;
    city: string | null;
    code: string;
}

export interface TripStop {
    code: string;
    destination?: string;
    nights: number;
}

export interface TripWidgetData {
    from: string;
    passengers: TripWidgetPassengers;
    trip: Trip;
}

export interface TripWidgetPassengers {
    adults: number;
    children: number[];
}
